import { IIndexedDbManager } from "./IIndexedDbManager";

/**
 * Zjednodušuje práci s jen jednou tabulkou (store) v databázi. Stačí její název uvést pouze jednou.
 */
export class IndexedDbView {
    protected _manager: IIndexedDbManager;
    protected readonly _storeName: string;

    constructor(databaseManager: IIndexedDbManager, storeName: string) {
        this._manager = databaseManager;
        this._storeName = storeName;
        this._manager.registerStore(storeName);
    }

    public getValue(name: string): Promise<any> {
        return this._manager.getValue(this._storeName, name);
    }

    public getAllValues(): Promise<any[]> {
        return this._manager.getAllValues(this._storeName);
    }

    public setValue(name: string, value: any): Promise<void> {
        return this._manager.setValue(this._storeName, name, value);
    }

    public clearAllValues(): Promise<void> {
        return this._manager.clearAllStoreValues(this._storeName);
    }
}
